/**
 * Converts Contentful's "Carousel" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import Container from '@material-ui/core/Container'
import Carousel from 'components/Carousel'
import ContentfulSection from '../ContentfulSection'

const ContentfulCarousel = ({
  id, sections,
}) => {
  if (!sections || sections.length === 0) return null

  const CarouselSections = sections.map((section) => (
    <ContentfulSection
      key={`${id}-${section.id}`}
      lg={5}
      md={12}
      {...section}
      titleSettings={{
        variant: 'h1',
        fontWeight: 400,
        ...(section?.titleSettings || {}),
      }} />
  ))

  return (
    <Container>
      <Carousel>
        {CarouselSections}
      </Carousel>
    </Container>
  )
}

ContentfulCarousel.propTypes = {
  id: PropTypes.string.isRequired,
  sections: PropTypes.array,
}

export default ContentfulCarousel
